import { atom } from 'jotai';
import { Nullable } from '@/types/generic';
import { SelectedVideoIds } from '@/types/video';
import { selectedVisEventsAtom } from './vis/selection';

export const selectedVideoIdsBaseAtom = atom<Nullable<SelectedVideoIds[]>>(null);

export const selectedVideoIdsAtom = atom(get => {
  const selectedVideoIds = get(selectedVideoIdsBaseAtom);
  const selectedVisEvents = get(selectedVisEventsAtom);
  const selectedVisEventsWithLicence = selectedVisEvents?.filter(({ hasVideo }) => hasVideo);

  const selectedVisArqamIds = selectedVisEventsWithLicence?.reduce(
    (acc, { eventId, videoEventId }) => (videoEventId ? [...acc, { eventId, videoEventId }] : acc),
    <SelectedVideoIds[]>[],
  );

  return selectedVisArqamIds?.length ? selectedVisArqamIds : selectedVideoIds;
});

export const selectedGameIdForVideosAtom = atom<Nullable<number>>(null);

export const unavailableVisVideosCountAtom = atom(get => {
  const selectedVisEvents = get(selectedVisEventsAtom);
  // If we've got no selected vis events, return here as we might still have selectedVideoIds
  // due to selecting videos to play from the events table.
  if (!selectedVisEvents) return 0;

  const selectedVideoIds = get(selectedVideoIdsAtom);

  const selectedVisEventsCount = selectedVisEvents.length;
  const selectedVideoIdsCount = selectedVideoIds?.length || 0;
  const unavailableVideosCount = selectedVisEventsCount - selectedVideoIdsCount;

  return unavailableVideosCount;
});
